import Box from '@mui/material/Box'
import CircularProgress from '@mui/material/CircularProgress'
import React from 'react'
import { useLocation, Navigate, Outlet } from 'react-router-dom'
import useAuth from '../../hooks/useAuth'
import useGlobalContext from '../../hooks/useGlobalContext'
import paths from '../../utils/paths'

export default function ProtectedRoute(): JSX.Element {
  const { user, authInformation } = useAuth()
  const { getCurrentTaxYearQueryResponse, getRolesFromUserQuery } = useGlobalContext()
  const location = useLocation()
  const { isLoading, data, isError } = getRolesFromUserQuery

  // Refetch `getCurrentTaxYearQueryResponse` when location or authInformation changes
  React.useEffect(() => {
    if (location && authInformation) {
      getCurrentTaxYearQueryResponse.refetch()
    }
  }, [getCurrentTaxYearQueryResponse, location, authInformation])

  React.useEffect(() => {
    if (location) {
      getRolesFromUserQuery.refetch()
    }
  }, [getRolesFromUserQuery, location])

  if (!user) {
    return <Navigate to={paths.login} replace />
  }

  if (authInformation?.isMcatUser) {
    return <Navigate to={paths.mcatHome} replace />
  }

  if (authInformation?.isMasterUser) {
    return <Navigate to={paths.masterHome} replace />
  }

  if (!isLoading && isError) {
    return <Navigate to={paths.unauthorized} replace />
  }

  if (isLoading || !data?.getRolesFromUser) {
    return (
      <Box display="flex" justifyContent="center" alignItems="center" height="100vh">
        <CircularProgress />
      </Box>
    )
  }

  return <Outlet />
}
